import React from "react";

import { Outlet } from "react-router-dom";

import { SnackbarOrigin } from "@mui/material";

import { MenuOpenContextProvider } from "commons/context/menu";
import { SnackbarContextProvider } from "commons/context/snackbar";
import { UiExtenderContextProvider } from "commons/context/uiExtender";

import { AuthContextProvider } from "context/auth";
import { UserContextProvider } from "context/user";

import RefreshTokenService from "service/RefreshTokenService";

function PlatformContextsContainer() {
    const snackbarAnchorOrigin: SnackbarOrigin = React.useMemo(
        () => ({ vertical: "bottom", horizontal: "right" }),
        []
    );

    return (
        <AuthContextProvider>
            <UserContextProvider>
                <RefreshTokenService>
                    <MenuOpenContextProvider maxWidthMenuPx={"1600px"}>
                        <UiExtenderContextProvider>
                            <SnackbarContextProvider anchorOrigin={snackbarAnchorOrigin}>
                                <Outlet />
                            </SnackbarContextProvider>
                        </UiExtenderContextProvider>
                    </MenuOpenContextProvider>
                </RefreshTokenService>
            </UserContextProvider>
        </AuthContextProvider>
    );
}

export default PlatformContextsContainer;
